import React, { useState, useEffect } from 'react';
import VideoModal from './VideoModal';
import { Modal } from 'Components/Base/Modal';

import { t } from 'i18n';

import { getVideo, createVideo, updateVideo } from './videosApi';

const i18nOpts = { scope: 'videos' };

const VideoModalWrapper = ({ allTags = [] }) => {
  const [videoData, setVideoData] = useState(null);
  const [videoId, setVideoId] = useState(null);
  const [isNewRecord, setIsNewRecord] = useState(true);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const handleOpenVideoModal = async (e) => {
      const { videoId, isNewRecord } = e.detail;
      setIsNewRecord(isNewRecord);
      setVideoId(videoId);

      if (isNewRecord) {
        setVideoData(null);
        setShowModal(true);
      } else {
        try {
          const data = await getVideo(videoId);
          setVideoData({
            videoUrl: data.video_url,
            videoName: data.name,
            description: data.description,
            tags: data.tags,
          });
          setShowModal(true);
        } catch (err) {
          console.error('Failed to load video data:', err);
        }
      }

      const modalTrigger = document.querySelector('#open');
      if (modalTrigger) modalTrigger.click();
    };

    window.addEventListener('openVideoModal', handleOpenVideoModal);
    return () => {
      window.removeEventListener('openVideoModal', handleOpenVideoModal);
    };
  }, []);

  const closeModal = () => setShowModal(false);

  const handleSubmit = async ({ videoUrl, videoName, videoDescription, currTags }) => {
    const videoData = {
      videoUrl,
      name: videoName,
      description: videoDescription,
      tags: currTags,
    };
  
    try {
      const response = isNewRecord
        ? await createVideo(videoData)
        : await updateVideo(videoId, videoData);
  
      closeModal();
      window.location.reload();
    } catch (error) {
      console.error('Error submitting video:', error);
    }
  };

  return (
    <Modal isOpen={showModal} closeModal={closeModal} title={isNewRecord ? t('add_new_video', i18nOpts) : t('update_video', i18nOpts)}>
      <VideoModal
        isNewRecord={isNewRecord}
        url={videoData?.videoUrl}
        name={videoData?.videoName}
        description={videoData?.description}
        tags={videoData?.tags}
        allTags={allTags}
        onSubmit={handleSubmit}
        onClose={closeModal}
      />
    </Modal>
  );
};


export default VideoModalWrapper;
